import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";

const RegexTextFieldInput = ({
    name,
    control,
    label,
    required = false,
    disabled = false,
    allowSpecChar = false,
    size = "medium",
    sx = {},
}) => {
    const labelWithAsterisk = required ? `${label} *` : label;

    const handleOnChange = (e, field) => {
    const inputValue = e.target.value;
    if(inputValue.length > 18) return;
    // allow only numbers, e, -, + and .
    if (allowSpecChar) {
        const filteredValue = inputValue.replace(/[^0-9:.-]/g, "");
        field.onChange(filteredValue);
    } else {
        const filteredValue = inputValue.replace(/[^0-9eE+\-.]/g, "");
        field.onChange(filteredValue);
    }

};

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={""}
            render={({ field }) => (
                <TextField
                    {...field}
                    fullWidth
                    label={labelWithAsterisk}
                    disabled={disabled}
                    size={size}
                    sx={sx}
                    onChange={(e) => handleOnChange(e, field)}
                    value={field.value ?? ""}
                />
            )}
        />
    );
};

export default RegexTextFieldInput;
